<div class="stripe-elements-container">
  <!-- Card information: one box holding number, expiry and CVC -->
  <div class="field-group">
    <label class="field-label">Card information</label>
    <div class="stripe-card-field" [class.is-focused]="cardFieldFocused" [class.has-error]="cardFieldError">
      <div class="scf-row scf-row--number">
        <div #cardNumberContainer class="scf-input"></div>
      </div>
      <div class="scf-row scf-row--split">
        <div #cardExpiryContainer class="scf-input scf-input--expiry"></div>
        <div #cardCvcContainer class="scf-input scf-input--cvc"></div>
      </div>
    </div>
    <p class="scf-error" *ngIf="cardFieldError">{{ cardFieldError }}</p>
  </div>

  <!-- Billing address -->
  <div class="field-group field-group--section">
    <label class="field-label">Billing address</label>
    <div #addressContainer class="stripe-element-wrapper"></div>
  </div>

  <!-- Error Message Display -->
  <div class="error-message" *ngIf="errorMessage">
    <mat-icon class="error-icon">error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="!areElementsLoaded">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Loading payment form...</span>
  </div>
</div>
